import React from 'react'
import styled, { css } from 'styled-components'
import theme from 'theme'
import { Typography } from 'components'

export const ButtonGroup = styled.div`
  display: flex;
  margin-top: auto;
  justify-content: ${(props) => (props.hideResetPassword ? 'center' : 'space-between')};
  margin-top: 15px;

  @media (max-width: 768px) {
    margin-top: 30px;
    padding: 20px;
  }
  @media (max-width: 375px) {
    padding: 0;
  }
`
export const ContainerLanguage = styled.div`
  position: absolute;
  right: 55px;
  top: 29px;
  display: flex;
  justify-content: space-between;
  width: 45px;
  @media (max-width: 426px) {
    top: -5px;
    right: 30px;
  }
`

export const ContainerLogo = styled.div`
  position: absolute;
  left: 50px;
  top: 24px;
  display: flex;
  justify-content: space-between;
  width: 45px;
  @media (max-width: 426px) {
    top: -10px;
    left: 35px;
  }
`

export const FormContainer = styled.div`
  ${({ isModal }) => {
    if (isModal) {
      return css`
        padding: 20px;
      `
    } else {
      return css`
        padding: 45px 60px;
        margin-top: 20px;
        @media screen and (max-width: 426px) {
          padding: 40px;
          margin-top: 30px;
        }
      `
    }
  }}
  overflow: auto;
  display: flex;
  width: 100%;
  flex-direction: column;
  height: 100%;
  box-sizing: border-box;
  justify-content: space-between;

  @media (max-width: 1024px) {
    height: 100%;
    flex-direction: column;
  }
`

export const Text = styled(Typography)`
  color: ${(props) => props.theme.primary2};
`
export const Container = styled.div`
  display: flex;
  height: 100%;
`
export const ContainerDivider = styled.div`
  background-color: transparent;
`
export const Divider = styled.hr`
  border-top: 1px solid ${theme.gray3};
`
export const GoogleButton = styled.img`
  width: 32px;
  height: 32px;
  cursor: pointer;
  @media (max-width: 820px) {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 768px) {
    height: 40px;
    width: 40px;
  }
  @media (max-width: 426px) {
    height: 36px;
    width: 36px;
  }
`
export const ClasswinLogo = styled.img`
  height: 40px;
  @media (max-width: 426px) {
    height: 36px;
  }
`
export const IconButton = styled.button`
  border: none;
  cursor: pointer;
  background: none;
`
export const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
  bottom: 30px;

  @media (max-width: 426px) {
    justify-content: center;
    position: absolute;
    bottom: 80px;
    right: 1px;
  }
`
export const FooterContentRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 5px;
`
export const LinkText = styled((props) => <Typography {...props} />)`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.gray2};

  :hover {
    text-decoration: underline;
  }
`
